import { render, staticRenderFns } from "./WhoWeAre.vue?vue&type=template&id=65d82f42&scoped=true&"
import script from "./WhoWeAre.vue?vue&type=script&lang=ts&"
export * from "./WhoWeAre.vue?vue&type=script&lang=ts&"
import style0 from "./WhoWeAre.vue?vue&type=style&index=0&id=65d82f42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d82f42",
  null
  
)

export default component.exports